import { useEffect, useState } from 'react';

import { getValidAssessmentOption } from '../utils/reportState';

export function useAssessmentOption<T extends number | string>(
  options: readonly { key: T }[],
  initialValue: T,
) {
  const [value, setValue] = useState(() =>
    getValidAssessmentOption(options, initialValue),
  );

  useEffect(() => {
    setValue((currentValue) => getValidAssessmentOption(options, currentValue));
  }, [options]);

  return [value, setValue] as const;
}
